<template>
  <div class="add flex-a-c icon" @click="$emit('add')">
    {{ $t('acit1') }} {{ name }}
  </div>
</template>

<script>
export default {
  name: "AddArBtn",
  props: {
    name: {
      type: String,
      default: '--'
    },
  },
}
</script>

<style lang="scss" scoped>
.add {
  width: calc(100% - 16px);
  background-color: #edfbff;
  height: 38px;
  min-height: 38px;
  border-radius: 8px;
  margin: 8px;
  border: 1px solid #409EFF;
  user-select: none;
}
</style>